import { render, staticRenderFns } from "./contactDom.vue?vue&type=template&id=b82c3116&scoped=true"
import script from "./contactDom.vue?vue&type=script&lang=js"
export * from "./contactDom.vue?vue&type=script&lang=js"
import style0 from "./contactDom.vue?vue&type=style&index=0&id=b82c3116&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82c3116",
  null
  
)

export default component.exports